import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { LOCAL_STORAGE_KEYS } from "../global/constant";
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class CommonApiService {
  private readonly baseUrl = environment.apiUrl;
  constructor(private http: HttpClient, private sharedService: SharedService) { }

  post(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.post(this.baseUrl + url, data, { headers });
    } else {
      return this.http.post(this.baseUrl + url, data);
    }
  }

  get(url: string, queryParams?: HttpParams) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      }); 
      return this.http.get(this.baseUrl + url, {
        params: queryParams,
        headers,
      });
    } else {
      return this.http.get(this.baseUrl + url, {
        params: queryParams,
      });
    }
  }

  update(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.put(this.baseUrl + url, data, { headers });
    } else {
      return this.http.put(this.baseUrl + url, data);
    }
  }

  patch(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        "company-id": companyId?.toString() || "",
      });
      return this.http.patch(this.baseUrl + url, data, { headers });
    }
    return this.http.patch(this.baseUrl + url, data);
  }

  delete(url: string, queryParams?: HttpParams) {
    return this.http.delete(this.baseUrl + url, {
      params: queryParams,
      headers: {
        'company-id': this.sharedService.getCompanyId()?.toString() || "",
      },
    });
  }

  public getParamsFromObj(obj: any): HttpParams {
    let params = new HttpParams();

    if (obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "" && obj[key] !== undefined) {
          params = params.set(key, obj[key]);
        }
      });
    }
    return params;
  }

  postBlob(url: string, data: any) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);

    return fetch(this.baseUrl + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
  }

  getBlob(url: string) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);
    return fetch(this.baseUrl + url, {
      method: "get",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }
}
